import React, { useContext } from 'react';
import styled from 'styled-components';
import Routes from 'Routes';
import { SearchFieldContext } from 'components/SearchFieldContext';
import TextHighlighter from 'components/TextHighlighter';
import SearchResultLink from './components/SearchResultLink';
import SearchResultImage from './components/SearchResultImage';

const ProfileContainer = styled.div`
  margin-left: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 58px;
  overflow: hidden;
  flex: 1 1 auto;
  width: 0;
`;

const NameContainer = styled.div`
  white-space: nowrap;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  padding: 4px;
  text-overflow: ellipsis;
  overflow: hidden;
`;

const CompanyTitleContainer = styled.div`
  white-space: nowrap;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  padding: 4px;
  text-overflow: ellipsis;
  overflow: hidden;
`;

const SpeakerSearchResultItem = ({
  webinarId,
  id,
  picture,
  name,
  company,
  title,
  variant,
}: {
  webinarId: string;
  id: string;
  picture: string;
  name: string;
  company: string;
  title: string;
  variant: 'compact' | 'standard';
}) => {
  const { searchKeyword } = useContext(SearchFieldContext);

  return (
    <SearchResultLink to={Routes.webinarSpeaker(webinarId, id)} variant={variant}>
      <SearchResultImage src={picture} variant={variant} />
      <ProfileContainer>
        {name && (
          <NameContainer>
            <TextHighlighter
              searchWords={[searchKeyword]}
              textToHighlight={name}
            />
          </NameContainer>
        )}
        {company && (
          <CompanyTitleContainer>
            <TextHighlighter
              searchWords={[searchKeyword]}
              textToHighlight={company}
            />
          </CompanyTitleContainer>
        )}
        {title && (
          <CompanyTitleContainer>
            <TextHighlighter
              searchWords={[searchKeyword]}
              textToHighlight={title}
            />
          </CompanyTitleContainer>
        )}
      </ProfileContainer>
    </SearchResultLink>
  );
};

export default SpeakerSearchResultItem;
